namespace TabAurous.Finance {
    export interface PDCReceivableRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        CreatedBy?: string;
        PartyId?: number;
        POSCustomerId?: number;
        LedgerName?: string;
        Amount?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Status?: string;
        Narration?: string;
        RefVoucherNo?: string;
        BankId?: number;
        VoucherTypeId?: number;
        FinancialYearId?: number;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        CompanyId?: number;
    }

    export namespace PDCReceivableRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PDCReceivable';
        export const deletePermission = 'Finance:PDCReceivable:Delete';
        export const insertPermission = 'Finance:PDCReceivable:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:PDCReceivable:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            CreatedBy = "CreatedBy",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Status = "Status",
            Narration = "Narration",
            RefVoucherNo = "RefVoucherNo",
            BankId = "BankId",
            VoucherTypeId = "VoucherTypeId",
            FinancialYearId = "FinancialYearId",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            CompanyId = "CompanyId"
        }
    }
}
